import './src/styles.css';

export const onClientEntry = () => {};
